export default __webpack_public_path__ + "static/media/footer-6.34abc7b5.jpg";